<template src="./list.html"></template>

<script>

import ServiceService from 'Services/ServiceService';

export default {
  data() {
    return {
      service: {},
      i18n: 2,
    };
  },

  created() {
    this.list();
  },

  methods: {
    list() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }

      const params = {
        type: 1,
        i18n: this.i18n,
      };


      ServiceService.listClient(params)
        .then((response) => {
          this.service = response.data;
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     white-space: pre-line;
}
</style>
